import * as React from 'react';
import { Link } from 'react-router';
import { __, __r } from 'react-i18n';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { InfoText, InfoType } from '../General/InfoText';
import { SecondStep as SecondStepSummary } from './Summary/SecondStep';
import { FormInput } from '../Form/FormInput';
import { RequestProductTable } from './Items/RequestProductTable';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { ItemsProductTable } from './Items/ImitradeItemsProductTable';
import { FreeDelivery } from './FreeDelivery';
import { prop } from '../../../utilities';

interface Props {
  theme: any;
  data: any;
  addToRequest: any;
  addToCart: any;
  isFetching: boolean;
  removeFromCart: any;
  changeCartItemNote: (gId: number, note: string) => void;
  changeCartNote: (note: string) => void;
  refreshCart: () => void;
  freeDel: number | null;
  isPriceWithVat: boolean;
  handlePaintChange: (goodId: number, wantPaint: boolean) => void;
  productHasPaint: boolean;
}

function SanitasCartItemsPart({
  theme,
  data,
  addToRequest,
  addToCart,
  isFetching,
  removeFromCart,
  changeCartItemNote,
  changeCartNote,
  refreshCart,
  freeDel,
  isPriceWithVat,
  handlePaintChange,
  productHasPaint,
}: Props) {
  const [requestsVisible, setRequestsVisible] = React.useState(true);
  const { items, user_id, cart_label, problems, total_items_price } = data;
  const [note, setNote] = React.useState(cart_label || '');
  const demands = items.filter(i => i.is_demand);
  const normalItems = items.filter(i => !i.is_demand);
  const hasNullPriceItems = items.some(i => i.sum_price === 0);

  const handleNoteChange = e => {
    setNote(e.target.value);
  };

  const handleNoteBlur = () => {
    changeCartNote(note);
  };

  const cartProblem = prop(
    problems.filter(p => p.type === 'cart')[0],
    'readable',
  );

  return (
    <Wrapper>
      {!user_id && (
        <InfoText
          noIcon={true}
          color="#000"
          type={InfoType.INFO}
          marginBottom={32}
          info={
            <>
              {__('Máte svoj účet?')}
              <LoginLink to={__r('routes:prihlasenie', 'prihlasenie')}>
                {__('Prihláste sa')}
              </LoginLink>
            </>
          }
        />
      )}

      {cartProblem && (
        <InfoText
          maxWidth={1168}
          type={InfoType.ERROR}
          info={cartProblem}
          marginBottom={56}
        />
      )}

      {normalItems.length > 0 && (
        <ItemsProductTable
          products={normalItems}
          isFetching={isFetching}
          addToCart={addToCart}
          removeFromCart={removeFromCart}
          refreshCart={refreshCart}
          isPriceWithVat={isPriceWithVat}
          handlePaintChange={handlePaintChange}
        />
      )}

      <OrderNrAndSummaryWrapper>
        <SecondStepSummary
          data={data}
          withoutBottomPart={true}
          isFetching={isFetching}
          freeDel={freeDel}
        />
      </OrderNrAndSummaryWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  width: 100%;
  margin-bottom: ${rem(32)};

  p {
    text-align: center;
  }

  ${({ theme }) => theme.mediab.m810`
      max-width: ${rem(400)};
      margin: 0 auto;
  `}
`;

const TitleWrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  padding-bottom: ${rem(32)};
  border-bottom: ${({ theme }) => theme.borders.primary};

  ${({ theme }) => theme.mediab.s450`
      margin: 0 -${rem(16)};
      padding: 0 ${rem(16)} ${rem(32)};
  `}
`;

const Title = styled.h3`
  font-size: ${rem(24)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
  line-height: ${rem(32)};
  font-weight: 400;
`;

const RequestsWrapper = styled(FlexCol)`
  display: none;

  ${({ theme }) => theme.mediab.m810`
    display: flex;
    margin-bottom: ${rem(24)};
  `}
`;

const DesktopWrapper = styled.div`
  ${({ theme }) => theme.mediab.m810`
    display: none;
  `}
`;

const LoginLink = styled(Link)`
  margin-left: ${rem(4)};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(14)};
  line-height: ${rem(18)};
`;

const OrderNrAndSummaryWrapper = styled(FlexRow)`
  justify-content: space-between;
  flex-flow: row wrap;
  margin-top: ${rem(8)};
  justify-content: flex-end;
  align-items: flex-end;

  ${({ theme }) => theme.mediab.m810`
      flex-flow: column;
      justify-content: center;
      align-items: center;
      max-width: ${rem(320)};
      width: 100%;
      margin: 0 auto;
  `}

  ${({ theme }) => theme.mediab.s450`
     max-width: initial;
     margin: initial;
  `}
`;

const WithTheme: any = withTheme(SanitasCartItemsPart);
export { WithTheme as SanitasCartItemsPart };
